import request from '@/utils/request'

export function getSubcontractorPage(params) {
  return request({
    url: '/api/subcontractor/page',
    method: 'get',
    params
  })
}

export function getSubcontractor(id) {
  return request({
    url: `/api/subcontractor/${id}`,
    method: 'get'
  })
}

export function saveSubcontractor(data) {
  return request({
    url: '/api/subcontractor',
    method: 'post',
    data
  })
}

export function updateSubcontractor(id, data) {
  return request({
    url: `/api/subcontractor/${id}`,
    method: 'put',
    data
  })
}

export function deleteSubcontractor(id) {
  return request({
    url: `/api/subcontractor/${id}`,
    method: 'delete'
  })
}
